(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-registry/assets/javascripts/use-get-betslip-force-type.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-registry/assets/javascripts/use-get-betslip-force-type.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$components$tipse = svs.components.tipsen.store.reducers.betslipSlice,
  selectBetslipType = _svs$components$tipse.selectBetslipType,
  betslipActions = _svs$components$tipse.actions;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const betslipForceTypes = svs.components.sport.tipsenShared.betslipForceTypes;
const selectCouponSignCount = svs.components.tipsen.engine.selectors.couponSelectors.selectCouponSignCount;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const useGetBetslipForceType = () => {
  const couponId = useCouponId();
  const dispatch = useDispatch();
  const isExtraSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const couponSignCount = useSelector(state => selectCouponSignCount(state, couponId));
  const betslipForceType = useSelector(state => selectBetslipType(state));
  useEffect(() => {
    if (couponSignCount > 0) {
      dispatch(betslipActions.setBetslipState({
        type: betslipForceTypes.BETSLIP
      }));
    }
    if (couponSignCount === 0 && !isExtraSmallDevice) {
      dispatch(betslipActions.setBetslipState({
        type: betslipForceTypes.NONE
      }));
    }
    if (couponSignCount === 0 && isExtraSmallDevice) {
      dispatch(betslipActions.setBetslipState({
        type: betslipForceTypes.MENU
      }));
    }
  }, [couponSignCount, dispatch, isExtraSmallDevice]);
  return betslipForceType;
};
setGlobal('svs.components.tipsen.betslipRegistry.useGetBetslipForceType', useGetBetslipForceType);

 })(window);